// since cats are super weird in Algolia, this finds the primary and constructs the right string
export function getCategoryTreeSlug(algoliaCategories) {
    // find the cat obj that's primary
    const catObj = algoliaCategories.find((catObj) => {
        // eslint-disable-next-line eqeqeq
        return catObj.primary == true
    })

    // shouldn't happen
    if (catObj === undefined) return undefined

    // get last cat level since it has the full breadcrumb
    let lastLevel = 0

    for (let i = 4; i >= 0; i--) {
        if (catObj[`lvl${i}`]) {
            lastLevel = i
            break
        }
    }

    return catObj[`lvl${lastLevel}`].slug.split('|').join('/')
}
